//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myQaQuestionAction from '../action/myQaQuestionAction';
import * as helpAction from '../action/helpAction';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import DatePicker, { registerLocale } from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import ja from 'date-fns/locale/ja'
import moment from 'moment';

import Dialog from '@material-ui/core/Dialog';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
//Add
import TextareaAutosize from 'react-textarea-autosize';

//Dialog
import DialogConfirm from './DialogConfirm';
//Part
import PartPageTitle from './PartPageTitle';
//Icon
import ClearIcon from '@material-ui/icons/Clear';
import CloseIcon from '@material-ui/icons/Close';

registerLocale('ja', ja);


class Comp extends React.Component {
  constructor(props) {
		super(props);

    this.state = {
      qaId: this.props.match.params.id,
      qaDate: new Date(),
      qaQuestion: '',
      qaQuestionLimit: 80,
      qaAnswer: ['', ''],
      qaListOpen: 1,
      qaWebmasterCheck: 3,
      qaAnswerDelIndex: null,
      qaAnswerCount: 0,

      saveDialogVisible: false,
      saveWebmasterCheckDialogVisible: false,
    }
	}

  componentDidMount() {
    document.title = 'Q&Aの編集 - パートナーズ';
    if (this.state.qaId !== 'add') {
      this._qaItemGet(this.state.qaId);
    }
  }

  _qaItemGet(qaId) {
    this.props.myQaQuestionItemGet(qaId, (data) => {
      this.setState({
        qaDate: moment(data.qa.qa_date).toDate(),
        qaQuestion: data.qa.qa_question,
        qaAnswer: data.qa.qa_answer,
        qaListOpen: data.qa.qa_list_open,
        qaWebmasterCheck: data.qa.qa_webmaster_check,
        qaAnswerCount: data.qa.qa_answer_count,
      });
    })
  }


  _onChangeDate(e) {
    this.setState({qaDate: e});
  }

  _renderAnswer(value, index, arr) {
		return (
			<div key={index} style={{margin:'15px'}}>
      <h3>
        回答.{ (index + 1) }
      </h3>
        <div
          style={{
            width:'100%',
            position:'relative',
          }}
        >

          <input
            value={value}
            onChange={(e) => this._answerEdit(index, 'edit', e.target.value)}
            style={{fontSize:'1.2em'}}
            maxLength={30}
            className={'input_blue round'}
          />
          <div align='right'>{value.length}/30文字</div>
          {
            (arr.length > 2) &&
            <IconButton
              size='small'
              style={{position:'absolute', top:'10px', right:'-20px',}}
              onClick={ () => this.setState({qaAnswerDelIndex: index}) }
            >
              <ClearIcon />
            </IconButton>
          }

        </div>
			</div>
		);
	}

  _answerEdit(index, type, value) {
    if (type === 'edit') {
      let newState = Object.assign([], this.state.qaAnswer);
      newState[index] = value;
      this.setState({qaAnswer: newState});
    }
    else if (type === 'add') {
      let newState = Object.assign([], this.state.qaAnswer);
      newState.push('');
      this.setState({qaAnswer: newState});
    }
    else if (type === 'del') {
      let newState = Object.assign([], this.state.qaAnswer);
      newState.push('');
      this.setState({qaAnswer: newState});
    }
  }

  _answerDel(index) {
    let newState = Object.assign([], this.state.qaAnswer);
    newState.splice(index, 1);
    this.setState({qaAnswer: newState, qaAnswerDelIndex: null});
  }


  _saveSubmit(check, unmount) {
    this.props.myQaQuestionSave(
      {
        qaId: this.state.qaId,
        qaDate: moment(this.state.qaDate).format('YYYY-MM-DD'),
        qaQuestion: this.state.qaQuestion,
        qaAnswer: this.state.qaAnswer,
        qaListOpen: this.state.qaListOpen,
        check: check,
      },
      (qaId) => {
        if (!unmount) {
          this.setState({qaId: qaId});
          this._qaItemGet(qaId);
        }
      }
    );
    this.setState({saveDialogVisible: false});
  }

  render() {

    let comp;
    if (this.props.my.setting.profileWebmasterCheck === 0) {
      comp = (
        <div>
          <h2 align='center'>プロフィールのコメントが未登録の為<br/>Q&Aは作成できません</h2>
        </div>
      )
    }
    else if (this.props.my.proof.credit === 0 && this.props.my.proof.person === 0) {
      comp = (
        <div>
          <h2 align='center'>本人証明が申請されていない為<br/>Q&Aは作成できません</h2>
          <div align='center' style={{padding:'10px'}}>
            <Button
              variant="contained"
              color='secondary'
              onClick={ () => this.props.history.push('/my/proof/person') }
              style={{fontSize:'1.2em'}}
            >
              本人証明を申請する
            </Button>
          </div>
        </div>
      )
    }
    else if (this.state.qaAnswerCount > 0 ) {
      comp = (
        <div>
          <h2 align='center'>このQ&Aには回答がある為<br/>再編集はできません</h2>

        </div>
      )
    }
    else {
      let checkIcon;
      if (this.state.qaWebmasterCheck === 0) {
      	checkIcon = (<span className='purple_icon'>申請中</span>);
      }
      else if (this.state.qaWebmasterCheck === 1) {
      	checkIcon = (<span className='orange_icon'>公開中</span>);
      }
      else if (this.state.qaWebmasterCheck === 2) {
      	checkIcon = (<span className='black_icon'>不承認</span>);
      }
      else if (this.state.qaWebmasterCheck === 3) {
      	checkIcon = (<span className='blue_icon'>未申請</span>);
      }


      let qaQuestionValidComment = null;

      if (this.state.qaQuestionLimit >= this.state.qaQuestion.length) {

      }
      else {
        qaQuestionValidComment= (<span style={{color:'red'}}>{(this.state.qaQuestionLimit - this.state.qaQuestion.length) * -1}文字オーバー</span>);
      }
      comp = (
        <div>
          <div style={{padding:'10px', color:'#666'}} align='center'>
            Q&Aは
            <u className='link' onClick={ () => this.props.helpOpen('id', 368) }>ガイドライン</u>
            のチェック後に公開されます
          </div>
          <div>
            <div style={{padding:'10px'}}>
              <div style={{margin:'15px'}}>
                {checkIcon}
              </div>
              <div style={{margin:'15px'}}>
                <h2>日付</h2>
                <DatePicker
                  onChange={ (e) => this._onChangeDate(e) }
                  locale="ja"
                  selected={ (this.state.qaDate) ? this.state.qaDate : new Date() }
                  maxDate={new Date()}
                  customInput={
                    <Button
                      style={{fontSize:'1.2em'}}
                      variant="outlined"
                    >
                      { moment(this.state.qaDate).format('YYYY-MM-DD') }
                    </Button>
                  }
                />

              </div>
              <div style={{margin:'15px'}}>
                <h2>公開範囲</h2>
                <FormControl variant="outlined">
                  <Select
                    value={this.state.qaListOpen}
                    onChange={ (e) => this.setState({qaListOpen: e.target.value})}
                  >
                    <MenuItem value={1}>みんなのQ&A &amp; プロフ</MenuItem>
                    <MenuItem value={0}>プロフ</MenuItem>
                  </Select>
                </FormControl>
                {(this.state.qaListOpen === 1) && (
                  <div style={{color:'#666'}}>「みんなのQ&A」と「ご自身のプロフィール」に掲載されます<br/>(個人的な質問は掲載できません)</div>
                )}
                {(this.state.qaListOpen === 0) && (
                  <div style={{color:'#666'}}>「自分のプロフィール」だけに掲載されます</div>
                )}
              </div>

              <div style={{margin:'15px'}}>
                <h3>
                  質問
                </h3>
                <TextareaAutosize
                  value={this.state.qaQuestion}
                  className= {(qaQuestionValidComment) ? "input_red round6" : "input_blue round6"}
                  onChange={(e) => this.setState({ qaQuestion: e.target.value})}
                  style={{
                    fontSize: '1.2em',
                  }}
                >
                </TextareaAutosize>
                <div align='right'>{qaQuestionValidComment} <span>{this.state.qaQuestion.length}/{this.state.qaQuestionLimit}文字</span></div>
              </div>

              {
                this.state.qaAnswer.map(
                  (value, index, arr) => this._renderAnswer(value, index, arr)
                )
              }
              {
                (this.state.qaAnswer.length < 10) && (
                  <div align='center'>
                    <Button
                      variant="outlined"
                      color="primary"
                      style={{minWidth:'240px'}}
                      onClick={ () => this._answerEdit(null, 'add', '')}
                    >
                      回答を追加する
                    </Button>
                  </div>
                )
              }
            </div>
          </div>
          <div>
            <div align='center' style={{margin:'15px'}}>
              <Button
                variant="outlined"
                color="primary"
                style={{fontSize:'1.2em'}}
                onClick={ () => {
                  if (this.state.qaWebmasterCheck !== 3) {
                    this.setState({saveDialogVisible: true})
                  }
                  else {
                    this._saveSubmit(3, false)
                  }
                }}
              >
                保存
              </Button>
              &nbsp;
              <Button
                variant="contained"
                color="primary"
                style={{fontSize:'1.2em'}}
                onClick={ () => this.setState({saveWebmasterCheckDialogVisible: true}) }
                disabled={ (this.state.qaQuestion && this.state.qaQuestion.length <= 80) ? false : true }
              >
                保存して公開申請
              </Button>
            </div>
          </div>

          <DialogConfirm
            open={ (this.state.saveDialogVisible) ? true : false }
            title={'Q&Aの保存'}
            content={
              (<div>Q&Aは保存すると未申請に戻ります。公開するには再度申請が必要です。</div>)
            }
            apply={ () => {
              this._saveSubmit(3, false);
              this.setState({saveDialogVisible: false});
            }}
            close={ () => this.setState({saveDialogVisible: null}) }
          />

          <Dialog
            open={this.state.saveWebmasterCheckDialogVisible}
            onClose={ () => this.setState({saveWebmasterCheckDialogVisible: false}) }
          >
            <div
              style={{
                display:'flex',
                flexDirection:'row',
                alignItems:'center',
                justifyContent:'space-between',
              }}
            >
              <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
                Q&Aの公開申請
              </div>
              <IconButton
                onClick={ () => this.setState({saveWebmasterCheckDialogVisible: false}) }
              >
                <CloseIcon/>
              </IconButton>
            </div>
            <div style={{maxWidth:'400px', margin:'15px'}}>
              Q&Aは <u className='link' onClick={ () => this.props.helpOpen('id', 368) }>ガイドライン</u>チェック後に公開されます。<br />
              Q&Aの承認はサポートの営業時間（10:00～19:00）に行っており、原則24時間以内に確認を行っております。<br />
              掲載まで今しばらくお待ちいただけますようお願い申し上げます。
            </div>
            <div align='center' style={{padding:'10px'}}>
              <Button
                variant="contained"
                color="primary"
                style={{fontSize:'1.1em'}}
                onClick={ () => {
                  this._saveSubmit(0, false);
                  this.setState({saveWebmasterCheckDialogVisible: false});
                }}
              >
                公開申請する
              </Button>
            </div>
          </Dialog>

          <DialogConfirm
            open={ (this.state.qaAnswerDelIndex !== null) ? true : false }
            title={'Q&Aの回答を削除'}
            content={'回答を1件削除してもいいですか？'}
            apply={ () => this._answerDel(this.state.qaAnswerDelIndex) }
            close={ () => this.setState({qaAnswerDelIndex: null}) }
          />

          <Snackbar
            open={this.state.saveSnackVisible}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            autoHideDuration={3000}
            onClose={ () => this.setState({saveSnackVisible: false})}
          >
            <MuiAlert severity="success" elevation={6} variant="filled">保存しました</MuiAlert>
          </Snackbar>
        </div>
      )
    }

    return (
      <div style={{maxWidth:'600px', margin:'auto'}}>
        <PartPageTitle
          title={'Q&Aの編集'}
          onback={ '/my/qa/question/' }
          helpType={ 'category' }
          helpFilter={ 'post' }
        />


        { comp }
      </div>
    )

  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myQaQuestionAction,
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
